"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planningHaulingTypes = void 0;
exports.planningHaulingTypes = {
    SET_ERROR: 'ADJUSTMENT PLANNING HAULING TYPES REDUCER SET ERROR',
    ON_PAGE_CHANGE: 'ADJUSTMENT PLANNING HAULING TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT PLANNING HAULING TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT PLANNING HAULING TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'ADJUSTMENT PLANNING HAULING TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT PLANNING HAULING TYPES ON SAVE DATAITEM',
    SET_DATA_GRID_HAULING: 'ADJUSTMENT PLANNING HAULING TYPES GET DATA GRID',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT PLANNING HAULING TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT PLANNING HAULING TYPES SET SUCCESS MODAL',
    ON_PAGE_CHANGE_BRAND: 'ADJUSTMENT PLANNING HAULING BRAND TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE_BRAND: 'ADJUSTMENT PLANNING HAULING BRAND TYPES ON SORT CHANGE',
    SET_DATA_GRID_HISTORY: 'ADJUSTMENT PLANNING HAULING TYPES GET DATA GRID HISTORY',
    ON_PAGE_CHANGE_HISTORY: 'ADJUSTMENT PLANNING HAULING HISTORY TYPES ON PAGE CHANGE',
    ON_FILTER_CHANGE_BRAND: 'ADJUSTMENT PLANNING HAULING BRAND TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE_HISTORY: 'ADJUSTMENT PLANNING HAULING HISTORY TYPES ON SORT CHANGE',
    SET_DATA_GRID_HAULING_BRAND: 'ADJUSTMENT PLANNING HAULING BRAND TYPES GET DATA GRID',
    ON_FILTER_CHANGE_HISTORY: 'ADJUSTMENT PLANNING HAULING HISTORY TYPES ON FILTER CHANGE',
    SET_LAST_SUCCEED_UPLOAD: 'ADJUSTMENT PLANNING HAULING HISTORY TYPES SET LAST SUCCEED UPLOAD',
};
